export const myListTimeSeriess = /* GraphQL */ `
  query MyListTimeSeriess(
    $symbol: String
    $frequency: ModelStringKeyConditionInput
    $filter: ModelTimeSeriesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTimeSeriess(
      symbol: $symbol
      frequency: $frequency
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        symbol
        frequency
        csvFile
        updatedAt
      }
      nextToken
    }
  }
`;
